import { AttachmentUploadModel } from './../../../models/Attachment/AttachmentUploadModel';
import { AttachmentService } from './../../../services/attachment.service';
import { EvaluationService } from './../../../services/evaluation.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ChangePasswordComponent } from './../../auth/change-password/change-password.component';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomerSummaryModel } from 'src/app/models/Profile/CustomerSummaryModel';
import { EvaluationSummaryModel } from 'src/app/models/Evaluation/EvaluationSummaryModel';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum'
import { AttachmentModelResult } from 'src/app/models/Attachment/AttachmnetModel';
import { IconService } from './../../../services/icon.service';
import  * as uuid from 'uuid';
import { Subscription } from 'rxjs';
import { NationalitieModel } from 'src/app/models/Profile/NationalitieModel';
import { ChangeEmailComponent } from '../../auth/change-email/change-email.component';

@Component({
  selector: 'view-my-profile',
  templateUrl: './view-my-profile.component.html',
  styleUrls: ['./view-my-profile.component.css']
})
export class ViewMyProfileComponent implements OnInit,OnDestroy {

  customerProfile: CustomerSummaryModel;
  currency;
  view: boolean = true;
  customerID;
  customerEvaluation: EvaluationSummaryModel;
  address: string;
  profilePicUrl;
  profilePicFile;
  profilePicAttachmentId;
  drivingLincesAttachmentUrl: string;
  identityAttachmnetModel: AttachmentModelResult;
  loadPassportAttachmentUrl: string;
  loggedInCustomer: any;
  subscriptions: Subscription[] = [];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private auth: AuthService,
    private service: SearchService,
    private router: Router,
    private evaluationService: EvaluationService,
    public translateService: TranslateService,
    private attachmentService: AttachmentService,
    private iconService:IconService,
    private elementRef: ElementRef

  ) {
    this.matIconRegistry.addSvgIcon(
      "champions-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.championsIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "booking-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.bookingIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "payment-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.paymentIcon)
    );
    //this.customerProfile = auth.getCustomerProfile();
    this.currency = service.getCurrency();
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
    this.elementRef.nativeElement.remove();
  }

  ngOnInit() {
    this.auth.loggedInCustomer.subscribe(res => {
      if (res != null) {
        this.loggedInCustomer=res;
        this.customerID = res.customerID;
        this.getCustomerSummary(this.customerID);
        this.evaluationService.customerEvaluation.subscribe(res => {
          if (res != null) {

            this.customerEvaluation = res;
          }
        })
        this.getProfilePic(res.customerID);


        this.attachmentService.getIdentityAttachemnt(this.customerID, AttachmentScopesEnum.Customer).subscribe(res => {
          this.identityAttachmnetModel=res;

        })
        /*
        this.auth.getCustomerSummary(res.customerID).subscribe(res =>{
          this.customerProfile=res;
        }) */
      }

    })


  }
  getProfilePic(customerID: any,appendRandomParam?) {
    // this.attachmentService.imageHandler(customerID, AttachmentScopesEnum.Customer, AttachmentTypeEnum.CustomerIndividualImage).subscribe(res => {
    //   if (res != null) {

    //     this.profilePicUrl = res;
    //   }

    // })
    let url= this.attachmentService.getImageLink(customerID, AttachmentScopesEnum.Customer, AttachmentTypeEnum.CustomerIndividualImage);
    if(appendRandomParam!=null){

    }
    url+='&random='+uuid.v4();
    this.profilePicUrl=url;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }
  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  getCustomerSummary(customerID,updateInfoMode?) {
    this.subscriptions.push(this.auth.getCustomerSummary(customerID).subscribe(res => {
      if(updateInfoMode!=null&&updateInfoMode){
        this.auth.saveCustomer(res);
      }



      this.customerProfile = res;
      this.fetchAndFormatLocation();
    }));
  }
  fetchAndFormatLocation() {
    if (this.customerProfile.locationDetails != null) {
      let root = this.customerProfile.locationDetails.filter(a => a.isRootLevel)[0];
      ;
      let tempDebug = this.getLocationRecursive(root.locationLevelID);
      this.address = root.defaultLocationName + this.getLocationRecursive(root.locationLevelID);

    }
  }
  getLocationRecursive(locationID) {
    let result = '';
    let _location = this.customerProfile.locationDetails.filter(a => a.parentID == locationID)[0];
    if (_location != null) {
      result += ' | ' + _location.defaultLocationName;
      result += this.getLocationRecursive(_location.locationLevelID);
    }
    else {
      return result;
    }
    return result;


  }

  EditProfile() {
    this.view = false;
  }

  ChangePassword() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(ChangePasswordComponent, dialogConfig);
  }

  ChangeEmail() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef=this.dialog.open(ChangeEmailComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null) {
          this.getCustomerSummary(this.customerID);
        }
      }
    );
  }


  changeViewType(isSaved) {


    setTimeout(() => {
      this.getProfilePic(this.customerID,true);
    });
    this.view = true;

    this.getCustomerSummary(this.customerID,isSaved);



  }
  onSelectFile(event) {

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      let reqModel: AttachmentUploadModel = {
        scopeId: AttachmentScopesEnum.Customer,
        typeId: AttachmentTypeEnum.CustomerIndividualImage,
        formFile: event.target.files[0],
        isIdintity: false,
        customerName: this.customerID,
        refernceID:this.customerID

      }
      let formData = this.attachmentService.modelToFormData(reqModel);
      this.attachmentService.uploadAttachmnet(formData).subscribe(res => {
        this.profilePicAttachmentId = res['result'];

      })
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.profilePicFile = event.target.files[0];
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.profilePicUrl = event.target.result;
      }
    }
  }

  loadDriverLinces() {

    if (this.drivingLincesAttachmentUrl == null) {
      let driverLincesAttachmnet=this.identityAttachmnetModel.attachmentModel.filter(a => a.attachmentTypeID==AttachmentTypeEnum.DrivingLicense)[0];
      if(driverLincesAttachmnet!=null){
        this.drivingLincesAttachmentUrl=driverLincesAttachmnet.attachmentURL;
        this.openInNewTab(this.drivingLincesAttachmentUrl);
      }

    }
    else {
      this.openInNewTab(this.drivingLincesAttachmentUrl);
    }

  }
  loadPassport() {

    if (this.loadPassportAttachmentUrl == null) {
      let passportAttachmnet=this.identityAttachmnetModel.attachmentModel.filter(a => a.attachmentTypeID==AttachmentTypeEnum.Passport)[0];
      if(passportAttachmnet!=null){
        this.loadPassportAttachmentUrl=passportAttachmnet.attachmentURL;
        this.openInNewTab(this.loadPassportAttachmentUrl);
      }

    }
    else {
      this.openInNewTab(this.loadPassportAttachmentUrl);
    }

  }
  loadAttachment() {

  }
   openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }



}
